import { UserTokenService } from '../../../core/services/user-token.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { _HttpClient } from 'src/app/core/net/http.client';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/core/services/settings.service';
import { ApiService } from 'src/app/core/net/apiRoute';
import { ChatService } from 'src/app/core/common/app-im/chat.service';


@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  error = '';
  public checkoutForm: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private token: UserTokenService,
    private settings: SettingsService,
    public http: _HttpClient) {
    this.checkoutForm = this.formBuilder.group({
      userName: [null, [Validators.required, Validators.minLength(5)]],
      password: [null, Validators.required],
    });

  }
  get userName() {
    return this.checkoutForm.controls.userName;
  }
  get password() {
    return this.checkoutForm.controls.password;
  }


  onSubmit(data) {
    this.userName.markAsDirty();
    this.userName.updateValueAndValidity();
    this.password.markAsDirty();
    this.password.updateValueAndValidity();
    if (this.userName.invalid || this.password.invalid) {
      this.error = '请输入手机号或密码';
      return;
    }

    this.http.post(ApiService.Login, {
      LoginType: 1,
      Phone: this.userName.value,
      Pwd: this.password.value
    })
      .subscribe((res: any) => {
        if (res.Status !== 1) {
          this.error = res.Message;
          return;
        }
        this.token.set(res.Result.token);
        this.settings.firstLogin = true;
        this.settings.setApp(this.settings.app);
        this.settings.setUser(res.Result.user);
        this.settings.setMenu(res.Result.menu);
        this.router.navigate(['/']);
      });
  }

  ngOnInit(): void {
  }

}
